var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',_vm._g(_vm._b({attrs:{"value":_vm.value}},'el-radio-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item){return _c('el-radio',{key:item.value,class:item.class,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }